export function formatName(first_name?: string | null, last_name?: string | null) {
  const nameText = [first_name, last_name].filter((x) => x).join(' ');
  if (!nameText) {
    return 'Unknown';
  }
  return nameText;
}
